/**
 * i18next の language（例: ja, ja-JP, en）から日本語向けアセットかどうかを判定する
 */
export function isJapaneseLocale(language: string | undefined): boolean {
    return (language ?? '').toLowerCase().startsWith('ja');
}
